export const validator = {
  validate: (formData) => {
    const errors = {};
    const warnings = {};

    const {
      gasEngineerDetails = {},
      vehicleOwnerDetails = {},
      lpgStorageCompartment = {},
      vehicleStructureAndVentilation = {},
      appliances = {},
      safetyNoticeAndSignOff = {}
    } = formData;

    if (!gasEngineerDetails.engineerName?.trim()) {
      errors['gasEngineerDetails.engineerName'] = 'Engineer name is required';
    }
    if (!gasEngineerDetails.gasSafeId?.trim()) {
      errors['gasEngineerDetails.gasSafeId'] = 'Gas Safe registration number is required';
    }
    if (!vehicleOwnerDetails.businessTradingName?.trim()) {
      errors['vehicleOwnerDetails.businessTradingName'] = 'Business / Trading name is required';
    }
    if (!vehicleOwnerDetails.vehicleRegOrVin?.trim()) {
      errors['vehicleOwnerDetails.vehicleRegOrVin'] = 'Vehicle Registration No. or VIN is required';
    }

    // Critical Safety Checks
    const pressureDrop = Number(vehicleStructureAndVentilation.testPressureDropMbar) || 0;
    if (pressureDrop > 0) {
      errors['vehicleStructureAndVentilation.testPressureDropMbar'] = 'Pressure drop detected. Installation must achieve 0.0 mbar drop to pass tightness test.';
    }

    if (appliances.appliance1Ffd === 'Failed') {
      errors['appliances.appliance1Ffd'] = 'Appliance 1 failed Flame Failure Device (FFD) test. All mobile catering appliances MUST have operational FFD.';
    }

    if (vehicleStructureAndVentilation.coAlarmFitted?.includes('No')) {
      warnings['vehicleStructureAndVentilation.coAlarmFitted'] = 'Audible CO alarm to BS EN 50291-2 is mandatory under UKLPG Code of Practice 24.';
    }

    if (!safetyNoticeAndSignOff.engineerSignature) {
      errors['safetyNoticeAndSignOff.engineerSignature'] = 'Gas Safe engineer signature is required';
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors,
      warnings
    };
  }
};

export default validator;
